import auth from "@/auth/index"
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    children: [
      {
        path: '/dataMigration',
        name: 'dataMigration',
        component: resolve => require(['@/views/dataMigration/index'], resolve),
        meta: {
          title: '数据迁移',
          breadLevel: 0,
          icon: 'icon-migration',
          auth: auth.datamigration
        }
      },
      {
        path: '/dataMigration/taskList',
        name: 'dataMigrationList',
        component: resolve => require(['@/views/dataMigration/migrationTaskList'], resolve),
        meta: {
          title: '数据迁移列表',
          breadLevel: 1,
          icon: 'icon-migration',
        }
      }
    ]
  }
]

export default routes
